import type en from "./en";

const de: typeof en = {
  vagueLinkText: [
    "hier klicken",
    "hier",
    "mehr lesen",
    "mehr",
    "weiter",
    "weiterlesen",
    "siehe mehr",
    "dies",
    "dieser link",
    "link",
    "klick",
  ],
  vagueButtonLabels: [
    "hier klicken",
    "klicken",
    "senden",
    "los",
    "ok",
    "okay",
    "ja",
    "nein",
  ],
  linkedImageActionHints: [
    "kaufen",
    "shoppen",
    "ansehen",
    "lesen",
    "lernen",
    "öffnen",
    "los",
    "sehen",
    "entdecken",
    "erkunden",
    "stöbern",
    "herunterladen",
    "holen",
    "abholen",
    "einlösen",
    "anschauen",
    "jetzt",
  ],
};

export default de;
